import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "../../../css/blogs.css"; // Import the CSS file

export const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];
  const maxPagesToShow = 5;

  let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

  // Adjust startPage if endPage is at the limit but there's space at the beginning
  if (endPage - startPage + 1 < maxPagesToShow && startPage > 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const getButtonClassName = (pageNumber) => {
    return `pagination-button ${
      currentPage === pageNumber ? "pagination-button-active" : ""
    }`;
  };

  const getIconButtonClassName = (isDisabled) => {
    return `pagination-button pagination-button-icon ${
      isDisabled ? "disabled" : ""
    }`;
  };

  return (
    <nav className="pagination-nav" aria-label="Pagination">
      {/* Previous page button */}
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        aria-label="Previous page"
        className={getIconButtonClassName(currentPage === 1)}
      >
        <ChevronLeft size={16} />
      </button>

      {/* Show '1' if it's not already displayed */}
      {startPage > 1 && (
        <>
          <button
            onClick={() => onPageChange(1)}
            className={getButtonClassName(1)}
          >
            1
          </button>
          {startPage > 2 && <span className="pagination-ellipsis">...</span>}
        </>
      )}

      {/* Show page numbers */}
      {pageNumbers.map((number) => (
        <button
          key={number}
          onClick={() => onPageChange(number)}
          className={getButtonClassName(number)}
        >
          {number}
        </button>
      ))}

      {/* Show the last page if it's not already displayed */}
      {endPage < totalPages && (
        <>
          {endPage < totalPages - 1 && (
            <span className="pagination-ellipsis">...</span>
          )}
          <button
            onClick={() => onPageChange(totalPages)}
            className={getButtonClassName(totalPages)}
          >
            {totalPages}
          </button>
        </>
      )}

      {/* Next page button */}
      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        aria-label="Next page"
        className={getIconButtonClassName(currentPage === totalPages)}
      >
        <ChevronRight size={16} />
      </button>
    </nav>
  );
};
